<template>
  <div class="area-edit-page">
    <el-tree
      :indent="30"
      :load="loadNode"
      :props="props"
      lazy
      accordion
      default-expand-all
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span
          class="custom-tree-node-name"
          style="width: 100px; text-align: left;"
        >
          <span>{{ node.label }}</span>
          <span class="custom-tree-node-comment">{{ data.comment }}</span>
        </span>
        <span class="custom-tree-node-content">
          <i
            class="el-icon-connection"
            @click.capture.prevent.stop="manageDevice(data)"
          ></i>
          <i
            class="el-icon-plus"
            style="margin-left: 18px"
            @click.capture.prevent.stop="addNode(node, data)"
          ></i>
          <i
            @click.capture.prevent.stop="editNode(data)"
            class="el-icon-edit"
            style="margin-left: 18px"
            v-if="node.level !== 1"
          ></i>
          <i
            @click.capture.prevent.stop="deleteNode(data)"
            class="el-icon-delete"
            style="margin-left: 18px"
            v-if="node.level !== 1"
          ></i>
        </span>
      </span>
    </el-tree>

    <el-dialog
      :visible.sync="dialogVisible"
      title="区域信息"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div
        class="div-2"
        v-if="!formInput.areaID && formInput.superArea !== '区域管理'"
      >
        <div class="div-2-title">上级区域：</div>
        <el-input v-model="formInput.superArea" :disabled="true"></el-input>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">区域名称：</div>
        <el-input v-model="formInput.name" maxlength="20"></el-input>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">区域说明：</div>
        <el-input v-model="formInput.comment" maxlength="50"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="medium"
          >取 消</el-button
        >
        <el-button
          type="primary"
          size="medium"
          @click="submitAddNode"
          :loading="dialogLoading"
          >{{ dialogLoading ? "提交中..." : " 确 定" }}</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogDeviceVisible"
      :title="deviceManageTitle"
      width="90%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="div-2-row">
        <div class="div-2-row">
          <div class="div-2-title">设备标签</div>
          <el-input
            v-model="formDeviceInput.tagName"
            style="width:100px;"
          ></el-input>
          <div style="margin: 0 12px">-</div>
          <el-input
            v-model="formDeviceInput.tagNum"
            style="width:100px;"
          ></el-input>
        </div>
        <div class="div-2-row">
          <div class="div-2-title">位置备注</div>
          <el-input v-model="formDeviceInput.comment"></el-input>
        </div>
        <div class="div-2-row">
          <el-button @click="bingDevice()" style="margin-left: 10px;"
            >绑定设备</el-button
          >
        </div>
      </div>
      <el-table style="margin-top: 30px" height="50vh" :data="deviceList">
        <el-table-column prop="mac" label="设备ID" align="center">
        </el-table-column>
        <el-table-column prop="devNum" label="标签" align="center">
        </el-table-column>
        <el-table-column prop="type" label="类型" align="center">
        </el-table-column>
        <el-table-column prop="comment" label="位置备注" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              plain
              size="mini"
              @click="editDevice(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              plain
              size="mini"
              @click="unbindDevice(scope.row)"
              >解绑</el-button
            >
            <el-button
              v-show="scope.row.type === '公寓门锁'"
              type="primary"
              plain
              size="mini"
              @click="authDevice(scope.row)"
              >钥匙授权</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      append-to-body
      :modal-append-to-body="false"
      :visible.sync="dialogAuthVisible"
      width="90%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <auth
        v-if="dialogAuthVisible"
        :bind-id="formDeviceInput.item.id"
        :dev-id="formDeviceInput.device.id"
        :bind-name="formDeviceInput.device.comment"
      ></auth>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { Loading } from "element-ui";
import Auth from "./Auth";

export default {
  name: "AreaEdit",

  components: { Auth },

  data() {
    return {
      props: {
        label: "name",
        children: "zones",
        isLeaf: "leaf"
      },
      dialogVisible: false,
      dialogDeviceVisible: false,
      dialogAuthVisible: false,
      formInput: {},
      formDeviceInput: {
        device: "",
        item: "",
        tagName: "",
        tagNum: "",
        comment: "",
      },
      dialogLoading: false,

      deviceList: [],

      title: "",

      deviceManageTitle: ""
    };
  },

  created() {
    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", "Web_Admin");
    this.title = decodeURI(this.$route.query.orgName || "");
  },

  methods: {
    addNode(node, data) {
      this.dialogVisible = true;
      this.formInput = {};
      this.formInput.superAreaID = data.id || "";
      this.formInput.superArea = data.name || "无";
    },

    editNode(data) {
      this.dialogVisible = true;
      this.formInput = { ...data };
      this.formInput.areaID = data.id;
    },

    deleteNode(data) {
      let shouldRefresh = false;

      this.$confirm(`此操作将删除【${data.name}】，是否继续？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          axios({
            method: "post",
            url: "areas/delete",
            data: {
              areaID: data.id
            }
          })
            .then(value => {
              let message = value.data.message;
              if (value.data.code === 0) {
                this.$notify({
                  title: "成功",
                  message: message,
                  type: "success"
                });
                shouldRefresh = true;
              } else {
                this.$notify({
                  title: "失败",
                  message: message,
                  type: "error"
                });
              }
            })
            .catch(e => {
              this.$notify({
                title: "失败",
                message: e.toString(),
                type: "error"
              });
            })
            .finally(() => {
              if (shouldRefresh) {
                setTimeout(() => {
                  // this.$router.go(0);
                  window.location.reload(true);
                }, 1500);
              }
            });
        })
        .catch(() => {});
    },

    submitAddNode() {
      if (this.formInput.name.length <= 0) {
        this.$message.error("请输入区域名称");
        return;
      }

      let data = { ...this.formInput };

      let url = "areas/add";
      if (data.areaID) {
        url = "areas/edit";
      }

      let shouldRefresh = false;

      axios({
        method: "post",
        url: url,
        data: data
      })
        .then(value => {
          let message = value.data.message;
          if (value.data.code === 0) {
            this.$notify({
              title: "成功",
              message: message,
              type: "success"
            });
            shouldRefresh = true;
          } else {
            this.$notify({
              title: "失败",
              message: message,
              type: "error"
            });
          }
        })
        .catch(e => {
          this.$notify({
            title: "失败",
            message: e.toString(),
            type: "error"
          });
        })
        .finally(() => {
          if (shouldRefresh) {
            setTimeout(() => {
              // this.$router.go(0);
              window.location.reload(true);
            }, 1500);
          }
        });
    },

    loadNode(node, resolve) {
      let superAreaID = "";

      if (node.level === 0) {
        resolve([
          {
            name: this.title
          }
        ]);
        return;
      }

      if (node.level > 1) {
        superAreaID = node.data.id;
      }

      axios({
        method: "post",
        url: "areas/query",
        data: {
          pageIdx: 0,
          pageSize: 100,
          superAreaID: superAreaID
        }
      })
        .then(value => {
          if (value.data.data) {
            resolve(value.data.data);
          }
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
    },

    async manageDevice(data) {
      this.deviceManageTitle = `【${data.name}】设备管理`;

      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });

      this.formDeviceInput.tagName = "";
      this.formDeviceInput.tagNum = "";
      this.formDeviceInput.comment = "";

      this.formDeviceInput.item = data;
      await this.getDeviceInfo();
      this.dialogDeviceVisible = true;
      loading.close();
    },

    async getDeviceInfo() {
      await axios({
        method: "post",
        url: "areas/devices",
        data: {
          areaID: this.formDeviceInput.item.id
        }
      }).then(value => {
        if (value.data.code === 0) {
          this.deviceList = value.data.data || [];
        }
      });
    },

    bingDevice() {
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      axios({
        method: "post",
        url: "areas/bind",
        data: {
          areaID: this.formDeviceInput.item.id,
          tagName: this.formDeviceInput.tagName,
          tagNum: parseInt(this.formDeviceInput.tagNum),
          comment: this.formDeviceInput.comment
        }
      })
        .then(value => {
          this.$message.info(value.data.message);
          if (value.data.code === 0) {
            this.formDeviceInput.tagName = "";
            this.formDeviceInput.tagNum = "";
            this.formDeviceInput.comment = "";
          }
        })
        .finally(_ => {
          loading.close();
          this.getDeviceInfo();
        });
    },

    unbindDevice(item) {
      this.$confirm(`是否解绑设备【 ${item.devNum} 】？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(_ => {
        const loading = Loading.service({
          lock: true,
          text: "正在请求...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)"
        });

        axios({
          method: "post",
          url: "areas/unbind",
          data: {
            devID: item.id,
            areaID: this.formDeviceInput.item.id
          }
        })
          .then(value => {
            this.$message.info(value.data.message);
          })
          .finally(_ => {
            loading.close();
            this.getDeviceInfo();
          });
      });
    },

    editDevice(item) {
      this.$prompt(`请输入【 ${item.devNum} 】的备注`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(value => {
        const loading = Loading.service({
          lock: true,
          text: "正在请求...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)"
        });

        axios({
          method: "post",
          url: "areas/devices/edit",
          data: {
            areaID: this.formDeviceInput.item.id,
            devID: item.id,
            comment: value.value
          }
        })
          .then(value => {
            this.$message.info(value.data.message);
          })
          .finally(_ => {
            loading.close();
            this.getDeviceInfo();
          });
      });
    },

    authDevice(item) {
      this.formDeviceInput.device = item; 
      this.dialogAuthVisible = true;
    }
  }
};
</script>

<style>
.el-tree-node__label {
  font-size: 18px;
  font-weight: bold;
}

.el-tree-node {
  margin-top: 8px;
}
</style>

<style scoped lang="scss">
@import "../../style.css";
.area-edit-page {
  box-sizing: border-box;
  padding: 20px;
  width: 60%;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.custom-tree-node-name {
  font-size: 15px;
  font-weight: bold;
}
.custom-tree-node-content {
  margin-left: 180px;
}
.custom-tree-node-comment {
  margin-left: 20px;
  font-size: 10px;
  color: lightgray;
}
.div-2-title {
  max-width: 100px !important;
  min-width: 100px !important;
}
</style>
